export const TagsQueueTracks = {
    ADD_TAG_QUEUE: 'helpdesk-queue-tag-add',
    REMOVE_TAG_QUEUE: 'helpdesk-queue-tag-remove',
};
